import _State from './_State.js';

const FoldersState = _State('folders', 'setFolders', []);

// Separate listeners for UI updates
FoldersState.uiListeners = new Set();

// Subscribe specifically for UI updates
FoldersState.subscribeToUI = function (listener) {
  this.uiListeners.add(listener);
  return () => {
    this.uiListeners.delete(listener);
  };
};

// Notify only UI listeners
FoldersState.notifyUIListeners = function () {
  const promises = Array.from(this.uiListeners).map(async listener => {
    try {
      return await listener(this.folders);
    } catch (error) {
      console.error('UI Listener error:', error);
      return null;
    }
  });
  return Promise.all(promises);
};

FoldersState.updateFolders = function (newFolders) {
  const result = this.setFolders(newFolders);
  this.notifyUIListeners();
  return result;
};

FoldersState.addFolder = function (folder) {
  const result = this.setFolders([...this.folders, folder]);
  this.notifyUIListeners();
  return result;
};

FoldersState.removeFolder = function (folderName) {
  const updatedFolders = this.folders.filter(
    folder => folder.name !== folderName,
  );
  const result = this.setFolders(updatedFolders);
  this.notifyUIListeners();
  return result;
};

FoldersState.toggleFileSelection = function (folderName, filePath, isSelected) {
  const updatedFolders = this.folders.map(folder => {
    if (folder.name === folderName) {
      return {
        ...folder,
        urls: folder.urls.map(url => {
          if (url.path === filePath) {
            return { ...url, selected: isSelected };
          }
          return url;
        }),
      };
    }
    return folder;
  });
  const result = this.setFolders(updatedFolders);
  this.notifyUIListeners();
  return result;
};

FoldersState.getSelectedFiles = function () {
  return this.folders.flatMap(folder =>
    folder.urls
      .filter(url => url.selected)
      .map(url => ({
        path: url.path,
        originalName: url.originalName || url.path.split('/').pop(),
        fileSize: url.fileSize,
        taskId: url.taskId,
        cadFileModelId: url.cadFileModelId,
        reconstructionId: url.reconstructionId,
        folderName: folder.name,
      })),
  );
};

FoldersState.getFileCount = function () {
  return this.folders.reduce(
    (acc, folder) => acc + folder.urls.filter(url => url.selected).length,
    0,
  );
};

export default FoldersState;
